export default __webpack_public_path__ + "static/media/welcomeBack.58350b44.png";